<template>
  <ui-dialog :show="isOpen" closable @input="close" max-width="623">
    <template #header>
      <h3 class="heading">
        {{ $t("message.facilityDetails.technicalDetailsDialog.title") }}
      </h3>
    </template>
    <template #default>
      <div class="containter">
        <p class="field-name">
          {{
            `${$t(
              "message.facilityDetails.technicalDetailsDialog.locationName"
            )}:`
          }}
        </p>
        <p class="mb-0">
          {{ locationName }}
        </p>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "TechnicalDetailsDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    locationName: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  margin-top: $spacing;
  line-height: 20px;
}

.containter {
  margin-top: $spacing;
  min-height: 100px;
}

.field-name {
  margin-bottom: 0;
  font-weight: 500;
  color: $text;
}
</style>
